import * as React from "react";
import "./BusSvg.css";
import { useContext } from "react";
import { ThemeContext, DetailContext, OrangeContext } from "../ThemeContext";

function SvgComponent() {
  const theme = useContext(ThemeContext);
  const detail = useContext(DetailContext);
  const orange = useContext(OrangeContext);
  return (
    <svg viewBox="0 0 1000 1000" height="300" width="300" style={theme}>
      <g id="road1">
        <path
          id="road2"
          className="st1"
          d="M214.5 740.7H75.1M431.5 740.7H232M792.5 740.7h-18.1M896.5 740.7h-86.6M918 740.7h-6.5M755 740.7H477M480.7 740.7H447M214.5 740.7H75.1M431.5 740.7H232M792.5 740.7h-18.1M896.5 740.7h-86.6M918 740.7h-6.5M755 740.7H477M480.7 740.7H447"
        />
      </g>
      <g id="road1">
        <g id="sun" className="st2">
          <path
            className="st3"
            d="M236.1 471.1c-23.1-23.4-37.3-55.6-37.3-91 0-71.6 58.1-129.7 129.7-129.7s129.8 58 129.8 129.6l-99.9-76-122.3 167.1z"
          />
        </g>
        <path
          className="st4"
          d="M328.6 215.8v14M328.6 189.8v14.6M328.6 157.7v19.1M300 218.3l2.5 13.7M295.5 192.7l2.6 14.4M289.9 161.1l3.4 18.8M272.4 225.7l4.8 13.1M263.5 201.3l5 13.7M252.5 171.1l6.6 18M246.4 237.8l7 12.1M233.5 215.3l7.3 12.7M217.4 187.5l9.6 16.6M223 254.2l9 10.7M206.3 234.3l9.4 11.2M185.6 209.7l12.4 14.7M202.8 274.5l10.7 8.9M182.9 257.8l11.1 9.4M158.2 237.1l14.7 12.3M186.3 297.9l12.1 7M163.8 284.9l12.7 7.3M136 268.8l16.6 9.6M174.2 323.9l13.2 4.7M149.8 315l13.8 5M119.6 304l18 6.5M166.8 351.5l13.8 2.4M141.3 347l14.3 2.5M109.6 341.4l18.9 3.3M164.3 380h14M138.4 380H153M106.2 380h19.2M166.8 408.5l13.8-2.4M141.3 413l14.3-2.5M109.6 418.6l18.9-3.3M174.2 436.2l13.2-4.8M149.8 445.1l13.8-5M119.6 456.1l18-6.6M186.3 462.1l12.1-7M163.8 475.1l12.7-7.3M136 491.2l16.6-9.6"
        />
        <g>
          <path
            className="st4"
            d="M470.8 297.9l-12.1 7M493.3 284.9l-12.7 7.3M521.1 268.8l-16.6 9.6"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M454.3 274.5l-10.6 8.9M474.2 257.8l-11.1 9.4M498.9 237.1l-14.7 12.3"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M434.1 254.2l-9 10.7M450.8 234.3l-9.4 11.2M471.5 209.7l-12.3 14.7"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M410.7 237.8l-7 12.1M423.6 215.3l-7.3 12.7M439.7 187.5l-9.6 16.6"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M384.7 225.7l-4.8 13.1M393.6 201.3l-5 13.7M404.6 171.1l-6.6 18"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M357.1 218.3l-2.5 13.7M361.6 192.7l-2.6 14.4M367.2 161.1l-3.4 18.8"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M202.5 487.6l10.8-8.9M182.4 503.9l11.2-9.1M157.4 524.3l14.9-12.2"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M222.4 508.1l9.2-10.6M205.5 527.7l9.5-11M184.4 552.1l12.6-14.5"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M245.6 524.9l7.2-12M232.3 547.1l7.5-12.5M215.8 574.8l9.9-16.5"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M271.4 537.4l5-13.1M262.2 561.7l5.2-13.7M250.8 591.7l6.7-17.9"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M298.9 545.2l2.6-13.8M294 570.7l2.8-14.4M288 602.2l3.6-18.8"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M479.5 438.5l-13.1-5M503.7 447.7l-13.6-5.1M533.7 459.2l-17.9-6.8"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M487.3 411l-13.7-2.7M512.8 415.9l-14.4-2.8M544.4 422l-18.9-3.7"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M490.3 382.5l-14-.2M516.2 382.9l-14.6-.2M548.3 383.4l-19.1-.3"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M488.2 353.9l-13.8 2.2M513.9 349.8l-14.5 2.3M545.6 344.7l-18.9 3.1"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M481.3 326.2l-13.2 4.6M505.8 317.7l-13.8 4.7M536.2 307.1l-18.2 6.3"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M382.7 540.3l-5-13.1M391.8 564.5l-5.2-13.6M403.1 594.6l-6.8-17.9"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M408.5 527.9l-7.2-12.1M421.7 550.2l-7.5-12.6M438.1 577.9l-9.8-16.5"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M431.7 511.2l-9.1-10.6M448.6 530.9l-9.5-11.1M469.5 555.3l-12.4-14.6"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M451.8 490.7l-10.9-8.9M471.9 507.2l-11.4-9.3M496.7 527.6l-14.8-12.1"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M467.9 467.1l-12.2-6.8M490.5 479.9l-12.7-7.2M518.6 495.6l-16.8-9.4"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M327.9 547.7l1-14M326 573.6l1.1-14.6M323.7 605.7l1.4-19.1"
          />
        </g>
        <g>
          <path
            className="st4"
            d="M356.5 547.3l-1.5-14M359.1 573.1l-1.4-14.6M362.5 605.1l-2-19.1"
          />
        </g>
        <circle className="st5" cx={328.6} cy={380} r={129} />
      </g>
      <g id="clouds1">
        <path
          className="st6"
          d="M624.3 275.8h142.4c.8-1.9 1.3-4.1 1.3-6.3 0-8.9-7.3-16.2-16.2-16.2-1.8 0-3.5.3-5 .8-3.7-10.1-13.5-17.3-24.9-17.3-3 0-5.9.5-8.6 1.4-5.7-12.6-18.5-21.4-33.2-21.4-20.2 0-36.5 16.3-36.5 36.5 0 2 .2 4 .5 6-9.2 1.7-16.6 8-19.8 16.5zM871.4 340.9v-.3c0-9.6-7.8-17.3-17.3-17.3-1.8 0-3.5.3-5.1.8v-1.5c0-15.2-12.3-27.5-27.5-27.5S794 307.4 794 322.6c0 1.6.1 3.1.4 4.6h-.4c-7.4 0-13.5 6-13.5 13.5v.4h90.9v-.2z"
        />
      </g>
      <g id="clouds2">
        <path
          className="st6"
          d="M624.3 275.8h142.4c.8-1.9 1.3-4.1 1.3-6.3 0-8.9-7.3-16.2-16.2-16.2-1.8 0-3.5.3-5 .8-3.7-10.1-13.5-17.3-24.9-17.3-3 0-5.9.5-8.6 1.4-5.7-12.6-18.5-21.4-33.2-21.4-20.2 0-36.5 16.3-36.5 36.5 0 2 .2 4 .5 6-9.2 1.7-16.6 8-19.8 16.5zM871.4 340.9v-.3c0-9.6-7.8-17.3-17.3-17.3-1.8 0-3.5.3-5.1.8v-1.5c0-15.2-12.3-27.5-27.5-27.5S794 307.4 794 322.6c0 1.6.1 3.1.4 4.6h-.4c-7.4 0-13.5 6-13.5 13.5v.4h90.9v-.2z"
        />
      </g>
      <g>
        <path className="st0" d="M335.9 333.3l-292 396.8h807.6z" />
        <path className="st7" d="M153 581.6l182.9-248.3L523 477.1" />
        <path className="st0" d="M522.1 297.9L207 730.1l793.3 4.8z" />
        <path
          className="st7"
          d="M391.4 475.3l130.7-177.4L744 499.4M276.8 414l9.1 11.7 22.1-8.8 28.7 11.1 11.8-11.1 22.4 7.4 12.1-18.5 28.5 11.4 11.2-17.2"
        />
        <path
          className="st7"
          d="M464.3 376.4l28.4-6.6L503 389l29.4-15.9 21.5 13.5 13.9-20.5 36 6"
        />
      </g>
      <g style={orange}>
        <path
          className="st0"
          d="M335.9 333.3l-292 396.8h807.6z"
          style={orange}
        />
        <path
          className="st7"
          d="M153 581.6l182.9-248.3L523 477.1"
          style={orange}
        />
        <path
          className="st0"
          d="M522.1 297.9L207 730.1l793.3 4.8z"
          style={orange}
        />
        <path
          className="st7"
          style={orange}
          d="M391.4 475.3l130.7-177.4L744 499.4M276.8 414l9.1 11.7 22.1-8.8 28.7 11.1 11.8-11.1 22.4 7.4 12.1-18.5 28.5 11.4 11.2-17.2"
        />
        <path
          className="st7"
          style={orange}
          d="M464.3 376.4l28.4-6.6L503 389l29.4-15.9 21.5 13.5 13.9-20.5 36 6"
        />
      </g>
      <g>
        <ellipse
          transform="rotate(-37.373 110.331 620.192)"
          className="st5"
          cx={110.3}
          cy={620.2}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.287 588.507)"
          className="st5"
          cx={110.3}
          cy={588.5}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.317 697.096)"
          className="st5"
          cx={110.3}
          cy={697.1}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.33 657.591)"
          className="st5"
          cx={110.3}
          cy={657.6}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.331 620.192)"
          className="st1"
          cx={110.3}
          cy={620.2}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.287 588.507)"
          className="st1"
          cx={110.3}
          cy={588.5}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.317 697.096)"
          className="st1"
          cx={110.3}
          cy={697.1}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.33 657.591)"
          className="st1"
          cx={110.3}
          cy={657.6}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-52.627 81.946 588.633)"
          className="st5"
          cx={81.9}
          cy={588.6}
          rx={7.8}
          ry={17.8}
        />
        <ellipse
          transform="rotate(-52.627 81.897 681.258)"
          className="st5"
          cx={81.9}
          cy={681.3}
          rx={7.8}
          ry={17.8}
        />
        <ellipse
          transform="rotate(-52.627 81.92 641.646)"
          className="st5"
          cx={81.9}
          cy={641.6}
          rx={7.8}
          ry={17.8}
        />
        <ellipse
          transform="rotate(-52.627 81.946 588.633)"
          className="st1"
          cx={81.9}
          cy={588.6}
          rx={7.8}
          ry={17.8}
        />
        <ellipse
          transform="rotate(-52.627 81.897 681.258)"
          className="st1"
          cx={81.9}
          cy={681.3}
          rx={7.8}
          ry={17.8}
        />
        <ellipse
          transform="rotate(-52.627 81.92 641.646)"
          className="st1"
          cx={81.9}
          cy={641.6}
          rx={7.8}
          ry={17.8}
        />
        <path className="st1" d="M96.1 593.5v145.3" />
        <ellipse
          transform="rotate(-37.373 193.338 704.779)"
          className="st1"
          cx={193.3}
          cy={704.8}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 193.338 671.58)"
          className="st1"
          cx={193.3}
          cy={671.6}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 193.316 641.587)"
          className="st1"
          cx={193.3}
          cy={641.6}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-52.627 164.894 681.25)"
          className="st1"
          cx={164.9}
          cy={681.2}
          rx={7.8}
          ry={17.8}
        />
        <ellipse
          transform="rotate(-52.627 164.917 641.638)"
          className="st1"
          cx={164.9}
          cy={641.6}
          rx={7.8}
          ry={17.8}
        />
        <path className="st1" d="M179.1 648.3v90.5" />
        <g>
          <path
            className="st5"
            d="M769.7 605.9l82.6-195.6c1.8-4.2 7.8-4.2 9.6 0l82.6 195.6c9.9 23.4-11.2 47.9-41.2 47.9h-92.4c-30 0-51.1-24.5-41.2-47.9z"
          />
          <path
            className="st5"
            d="M769.7 605.9l82.6-195.6c1.8-4.2 7.8-4.2 9.6 0l82.6 195.6c9.9 23.4-11.2 47.9-41.2 47.9h-92.4c-30 0-51.1-24.5-41.2-47.9z"
          />
          <path
            className="st8"
            d="M810.1 615.1L869 427l-7-16.7c-1.8-4.2-7.8-4.2-9.6 0l-82.6 195.6c-9.9 23.4 11.2 47.9 41.2 47.9h7c-8.8-7.4-12.2-19.7-7.9-38.7z"
          />
          <path
            className="st1"
            d="M857.1 740.7V446.3M880.9 487.3L857.1 510l-23.7-22.7M885.4 530.5l-28.3 27.1-28.3-27.1M904.3 579.7l-47.2 37.5-47.2-37.5"
          />
        </g>
      </g>
      <g>
        <ellipse
          transform="rotate(-37.373 110.331 620.192)"
          className="st5"
          cx={110.3}
          cy={620.2}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.287 588.507)"
          className="st5"
          cx={110.3}
          cy={588.5}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.317 697.096)"
          className="st5"
          cx={110.3}
          cy={697.1}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.33 657.591)"
          className="st5"
          cx={110.3}
          cy={657.6}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.331 620.192)"
          className="st1"
          cx={110.3}
          cy={620.2}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.287 588.507)"
          className="st1"
          cx={110.3}
          cy={588.5}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.317 697.096)"
          className="st1"
          cx={110.3}
          cy={697.1}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 110.33 657.591)"
          className="st1"
          cx={110.3}
          cy={657.6}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-52.627 81.946 588.633)"
          className="st5"
          cx={81.9}
          cy={588.6}
          rx={7.8}
          ry={17.8}
        />
        <ellipse
          transform="rotate(-52.627 81.897 681.258)"
          className="st5"
          cx={81.9}
          cy={681.3}
          rx={7.8}
          ry={17.8}
        />
        <ellipse
          transform="rotate(-52.627 81.92 641.646)"
          className="st5"
          cx={81.9}
          cy={641.6}
          rx={7.8}
          ry={17.8}
        />
        <ellipse
          transform="rotate(-52.627 81.946 588.633)"
          className="st1"
          cx={81.9}
          cy={588.6}
          rx={7.8}
          ry={17.8}
        />
        <ellipse
          transform="rotate(-52.627 81.897 681.258)"
          className="st1"
          cx={81.9}
          cy={681.3}
          rx={7.8}
          ry={17.8}
        />
        <ellipse
          transform="rotate(-52.627 81.92 641.646)"
          className="st1"
          cx={81.9}
          cy={641.6}
          rx={7.8}
          ry={17.8}
        />
        <path className="st1" d="M96.1 593.5v145.3" />
        <ellipse
          transform="rotate(-37.373 193.338 704.779)"
          className="st1"
          cx={193.3}
          cy={704.8}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 193.338 671.58)"
          className="st1"
          cx={193.3}
          cy={671.6}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-37.373 193.316 641.587)"
          className="st1"
          cx={193.3}
          cy={641.6}
          rx={17.8}
          ry={7.8}
        />
        <ellipse
          transform="rotate(-52.627 164.894 681.25)"
          className="st1"
          cx={164.9}
          cy={681.2}
          rx={7.8}
          ry={17.8}
        />
        <ellipse
          transform="rotate(-52.627 164.917 641.638)"
          className="st1"
          cx={164.9}
          cy={641.6}
          rx={7.8}
          ry={17.8}
        />
        <path className="st1" d="M179.1 648.3v90.5" />
        <g>
          <path
            className="st5"
            d="M769.7 605.9l82.6-195.6c1.8-4.2 7.8-4.2 9.6 0l82.6 195.6c9.9 23.4-11.2 47.9-41.2 47.9h-92.4c-30 0-51.1-24.5-41.2-47.9z"
          />
          <path
            className="st5"
            d="M769.7 605.9l82.6-195.6c1.8-4.2 7.8-4.2 9.6 0l82.6 195.6c9.9 23.4-11.2 47.9-41.2 47.9h-92.4c-30 0-51.1-24.5-41.2-47.9z"
          />
          <path
            className="st8"
            d="M810.1 615.1L869 427l-7-16.7c-1.8-4.2-7.8-4.2-9.6 0l-82.6 195.6c-9.9 23.4 11.2 47.9 41.2 47.9h7c-8.8-7.4-12.2-19.7-7.9-38.7z"
          />
          <path
            className="st1"
            d="M857.1 740.7V446.3M880.9 487.3L857.1 510l-23.7-22.7M885.4 530.5l-28.3 27.1-28.3-27.1M904.3 579.7l-47.2 37.5-47.2-37.5"
          />
        </g>
      </g>
      <g>
        <path
          className="st9"
          d="M340.9 740.7c-25.3 0-45.9-20.6-45.9-45.9 0-25.3 20.6-45.9 45.9-45.9s45.9 20.6 45.9 45.9c0 25.3-20.6 45.9-45.9 45.9z"
        />
        <path
          className="st1"
          d="M340.9 740.7c-25.3 0-45.9-20.6-45.9-45.9 0-25.3 20.6-45.9 45.9-45.9s45.9 20.6 45.9 45.9c0 25.3-20.6 45.9-45.9 45.9z"
        />
        <path
          className="st5"
          d="M340.9 718.8c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24z"
        />
        <path
          className="st1"
          d="M340.9 718.8c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24z"
        />
        <path
          className="st5"
          d="M340.9 702.7c-4.4 0-7.9-3.6-7.9-7.9 0-4.4 3.6-7.9 7.9-7.9 4.4 0 7.9 3.6 7.9 7.9 0 4.3-3.5 7.9-7.9 7.9z"
        />
        <path
          className="st1"
          d="M340.9 702.7c-4.4 0-7.9-3.6-7.9-7.9 0-4.4 3.6-7.9 7.9-7.9 4.4 0 7.9 3.6 7.9 7.9 0 4.3-3.5 7.9-7.9 7.9z"
        />
        <g>
          <path
            className="st9"
            d="M599 740.7c-25.3 0-45.9-20.6-45.9-45.9 0-25.3 20.6-45.9 45.9-45.9 25.3 0 45.9 20.6 45.9 45.9 0 25.3-20.6 45.9-45.9 45.9z"
          />
          <path
            className="st1"
            d="M599 740.7c-25.3 0-45.9-20.6-45.9-45.9 0-25.3 20.6-45.9 45.9-45.9 25.3 0 45.9 20.6 45.9 45.9 0 25.3-20.6 45.9-45.9 45.9z"
          />
          <path
            className="st5"
            d="M599 718.8c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24z"
          />
          <path
            className="st1"
            d="M599 718.8c-13.2 0-24-10.8-24-24s10.8-24 24-24 24 10.8 24 24-10.8 24-24 24z"
          />
          <path
            className="st5"
            d="M599 702.7c-4.4 0-7.9-3.6-7.9-7.9 0-4.4 3.6-7.9 7.9-7.9 4.4 0 7.9 3.6 7.9 7.9 0 4.3-3.5 7.9-7.9 7.9z"
          />
          <path
            className="st1"
            d="M599 702.7c-4.4 0-7.9-3.6-7.9-7.9 0-4.4 3.6-7.9 7.9-7.9 4.4 0 7.9 3.6 7.9 7.9 0 4.3-3.5 7.9-7.9 7.9z"
          />
        </g>
        <g id="van-body">
          <path
            className="st10"
            style={detail}
            id="van-body"
            d="M707.9 555.1l-9.4-35.7c-3.7-14.3-15.9-24.7-30.6-26.3-42-4.5-92.9-7.1-152.3-7.1-68 0-172.5 5.2-203.9 8.8-5.7.6-10.6 4.3-12.9 9.6l-18.9 44.2c-8.7 15.6-14 32.8-15.5 50.6l-.4 99.4 21.1.4c-.1-1.4-.2-2.8-.2-4.2 0-30.9 25-55.9 55.9-55.9s55.9 25 55.9 55.9c0 1.8-.1 3.6-.3 5.3l147 1.8c-.3-2.3-.5-4.7-.5-7.1 0-30.9 25-55.9 55.9-55.9s55.9 25 55.9 55.9c0 2.8-.2 5.5-.6 8.2l59.3.6V600c.3-15.1-1.7-30.2-5.5-44.9z"
          />
          <g className="st11">
            <path
              className="st10"
              d="M275.2 698.6l.4-99.4c1.5-17.8 6.8-35 15.5-50.6l18.9-44.2c2.3-5.3 7.2-8.9 12.9-9.6 30.5-3.5 129.8-8.5 197.8-8.8h-5.1c-68 0-172.5 5.2-203.9 8.8-5.7.6-10.6 4.3-12.9 9.6l-18.9 44.2c-8.7 15.6-14 32.8-15.5 50.6l-.4 99.4 21.1.4v-.2l-9.9-.2zM665.5 703c.4-2.7.6-5.4.6-8.2 0-30.9-25-55.9-55.9-55.9-1.9 0-3.7.1-5.6.3 28.3 2.8 50.3 26.6 50.3 55.6 0 2.8-.2 5.5-.6 8.2l59.3.6v-.1l-48.1-.5z"
            />
            <path
              className="st10"
              d="M407.7 700c.2-1.7.3-3.5.3-5.3 0-30.9-25-55.9-55.9-55.9-1.9 0-3.7.1-5.6.3 28.3 2.8 50.3 26.6 50.3 55.6 0 1.8-.1 3.6-.3 5.3l147 1.8v-.1L407.7 700z"
            />
          </g>
          <path
            className="st12"
            d="M407.9 691h133.6v-13.3H405.3c1.4 4.3 2.2 8.7 2.6 13.3z"
          />
          <g className="st13">
            <path
              className="st10"
              d="M709.9 554.1l-9.4-35.7c-3.7-14.3-15.9-24.7-30.6-26.3-42-4.5-92.9-7.1-152.3-7.1-68 0-172.5 5.2-203.9 8.8-4.9.6-9.3 3.4-11.8 7.6 0 0 0-1.7.1-1.7 31.4-3.6 135.9-7.1 203.9-7.1 59.5 0 110.3 2.6 152.3 7.1 14.7 1.6 26.8 12 30.6 26.3l9.4 35.7c3.9 14.7 5.8 29.8 5.8 44.9v95.9l11.8.1V599c-.1-15.1-2.1-30.2-5.9-44.9z"
            />
          </g>
          <path
            className="st1"
            d="M707.9 555.1l-9.4-35.7c-3.7-14.3-15.9-24.7-30.6-26.3-42-4.5-92.9-7.1-152.3-7.1-68 0-172.5 5.2-203.9 8.8-5.7.6-10.6 4.3-12.9 9.6l-18.9 44.2c-8.7 15.6-14 32.8-15.5 50.6l-.4 99.4 21.1.4c-.1-1.4-.2-2.8-.2-4.2 0-30.9 25-55.9 55.9-55.9s55.9 25 55.9 55.9c0 1.8-.1 3.6-.3 5.3l147 1.8c-.3-2.3-.5-4.7-.5-7.1 0-30.9 25-55.9 55.9-55.9s55.9 25 55.9 55.9c0 2.8-.2 5.5-.6 8.2l59.3.6V600c.3-15.1-1.7-30.2-5.5-44.9z"
          />
          <path
            className="st14"
            d="M264 707.5h-10.9c-4.5 0-8.1-3.6-8.1-8.1v-32.3c0-4.5 3.6-8.1 8.1-8.1H264v48.5z"
          />
          <path
            className="st1"
            d="M264 707.5h-10.9c-4.5 0-8.1-3.6-8.1-8.1v-32.3c0-4.5 3.6-8.1 8.1-8.1H264v48.5z"
          />
          <path
            className="st14"
            d="M265.6 646h-4c-3 0-5.4-2.4-5.4-5.4v-24.8c0-3 2.4-5.4 5.4-5.4h4c3 0 5.4 2.4 5.4 5.4v24.8c0 3-2.4 5.4-5.4 5.4z"
          />
          <path
            className="st1"
            d="M265.6 646h-4c-3 0-5.4-2.4-5.4-5.4v-24.8c0-3 2.4-5.4 5.4-5.4h4c3 0 5.4 2.4 5.4 5.4v24.8c0 3-2.4 5.4-5.4 5.4z"
          />
          <path
            className="st14"
            style={detail}
            d="M721.3 715.2h-43c-5 0-9-4-9-9v-7c0-5 4-9 9-9h43c5 0 9 4 9 9v7c0 4.9-4.1 9-9 9z"
          />
          <path
            className="st15"
            d="M678.9 705.5c0-2.5 2.1-4.6 4.6-4.6h46.7v-1.7c0-5-4-9-9-9h-43c-5 0-9 4-9 9v7c0 5 4 9 9 9h.7v-9.7z"
          />
          <path
            className="st1"
            d="M721.3 715.2h-43c-5 0-9-4-9-9v-7c0-5 4-9 9-9h43c5 0 9 4 9 9v7c0 4.9-4.1 9-9 9z"
          />
          <path
            className="st5"
            d="M648.5 578.3h-46.3c-5.3 0-9.6-4.3-9.6-9.6V522c0-5.3 4.3-9.6 9.6-9.6h28.1c11.1 0 20.5 8.1 22.2 19.1l5.4 35.7c1 5.9-3.5 11.1-9.4 11.1z"
          />
          <path
            className="st8"
            style={detail}
            d="M612.2 533.5c0-5.3 4.3-9.6 9.6-9.6h28.1a22.49 22.49 0 00-19.6-11.4h-28.1c-5.3 0-9.6 4.3-9.6 9.6v46.7c0 5.3 4.3 9.6 9.6 9.6h10v-44.9z"
          />
          <path
            className="st1"
            d="M648.5 578.3h-46.3c-5.3 0-9.6-4.3-9.6-9.6V522c0-5.3 4.3-9.6 9.6-9.6h28.1c11.1 0 20.5 8.1 22.2 19.1l5.4 35.7c1 5.9-3.5 11.1-9.4 11.1z"
          />
          <path
            className="st5"
            d="M561.8 577.3H459.6c-5.3 0-9.6-4.3-9.6-9.6V521c0-5.3 4.3-9.6 9.6-9.6h102.2c5.3 0 9.6 4.3 9.6 9.6v46.7c-.1 5.3-4.3 9.6-9.6 9.6z"
          />
          <path
            className="st8"
            style={detail}
            d="M468.5 531.3c0-5.3 4.3-9.6 9.6-9.6h93.2v-.7c0-5.3-4.3-9.6-9.6-9.6H459.6c-5.3 0-9.6 4.3-9.6 9.6v46.7c0 5.3 4.3 9.6 9.6 9.6h9v-46h-.1z"
          />
          <path
            className="st1"
            d="M561.8 577.3H459.6c-5.3 0-9.6-4.3-9.6-9.6V521c0-5.3 4.3-9.6 9.6-9.6h102.2c5.3 0 9.6 4.3 9.6 9.6v46.7c-.1 5.3-4.3 9.6-9.6 9.6z"
          />
          <path
            className="st5"
            d="M403.5 578.3h-96.3c-5.4 0-9.3-6-7.8-12.1l11.1-46.7c1-4.1 4.2-7 7.8-7h85.2c4.5 0 8.1 4.3 8.1 9.6v46.7c.1 5.2-3.6 9.5-8.1 9.5z"
          />
          <path
            className="st8"
            style={detail}
            d="M317.4 576l11.1-46.7c1-4.1 4.2-7 7.8-7h75.3v-.3c0-5.3-3.6-9.6-8.1-9.6h-85.2c-3.6 0-6.8 2.9-7.8 7l-11.1 46.7c-1.4 6.1 2.4 12.1 7.8 12.1h9.9c.1-.7.2-1.4.3-2.2z"
          />
          <path
            className="st1"
            d="M403.5 578.3h-96.3c-5.4 0-9.3-6-7.8-12.1l11.1-46.7c1-4.1 4.2-7 7.8-7h85.2c4.5 0 8.1 4.3 8.1 9.6v46.7c.1 5.2-3.6 9.5-8.1 9.5z"
          />
          <path
            className="st16"
            d="M413.4 490.7c11.4 0 20.6 9.2 20.6 20.6v189.2"
          />
          <path className="st1" d="M386.8 602.3h30M542.5 600h25.6" />
          <path
            className="st15"
            d="M716.3 669.5h-3.9V574h3.9c6.6 0 12 5.4 12 12v71.5c0 6.6-5.4 12-12 12z"
          />
          <path
            className="st1"
            d="M716.3 669.5h-3.9V574h3.9c6.6 0 12 5.4 12 12v71.5c0 6.6-5.4 12-12 12zM669.3 522.5h12.1M674.3 539.7h12.1M679 556.8h12.1M681 574h12.2"
          />
          <path
            className="st14"
            style={detail}
            d="M534.8 706.7H405.5c-5.4 0-9.7-4.3-9.7-9.7 0-5.4 4.3-9.7 9.7-9.7h129.3c5.4 0 9.7 4.3 9.7 9.7 0 5.3-4.3 9.7-9.7 9.7z"
          />
          <path
            className="st14"
            style={detail}
            d="M534.8 706.7H405.5c-5.4 0-9.7-4.3-9.7-9.7 0-5.4 4.3-9.7 9.7-9.7h129.3c5.4 0 9.7 4.3 9.7 9.7 0 5.3-4.3 9.7-9.7 9.7z"
          />
          <path className="st15" d="M395.8 687.3h148.7v9.7H395.8z" />
          <path
            className="st1"
            d="M534.8 706.7H405.5c-5.4 0-9.7-4.3-9.7-9.7 0-5.4 4.3-9.7 9.7-9.7h129.3c5.4 0 9.7 4.3 9.7 9.7 0 5.3-4.3 9.7-9.7 9.7z"
          />
          <path
            className="st17"
            d="M326.2 553.5l19.6-19.7M342.8 555.3l26.4-26.6M478.5 551.2l19.5-19.8M495.1 553l26.4-26.6M605.3 553.1l16.1-16.3M619 554.6l21.7-22"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
